<script>

    import VTooltipWrapper from '../v-tooltip-wrapper.vue'

    export default {
        name: "statusbar-icon",
        components: { VTooltipWrapper },
        props: {
            tooltipText: String,
            iconClass: String,
            icon: String,
            eicon: Boolean
        },
        computed: {
            style() {
                if (this.eicon) return 'position: relative; top: 2px';
            }
        }
    }
</script>

<template>
    <v-tooltip-wrapper>
        <template #activator="{ on, attrs }">
            <div v-on="on"
                 v-bind="attrs"
                class="mx-1"
                :style="style"
                 style="cursor: help;"
            >
                <eicon v-if="eicon" :kind="icon" :class="iconClass" aria-hidden="true" fontColor/>
                <i v-else :class="`fa-solid fa-${icon} ${iconClass}`" aria-hidden="true"/>
            </div>
        </template>
        <span v-html="tooltipText"></span>
    </v-tooltip-wrapper>
</template>

